import { EventToolbox } from 'client/utils/event-toolbox';
import { TrackingConstant } from 'client/tracking/constant';
import { FOLLOWUP_CREATIVE_ID } from 'site-modules/shared/constants/personalized-search/personalized-search';

export function fireWidgetViewTracking({ creativeId }) {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_WIDGET_VIEW,
    event_data: {
      action_name: TrackingConstant.ACTION_WIDGET_VIEW,
      action_cause: TrackingConstant.ACTION_CAUSE_SCROLL,
      total_page_height: Math.max(document.body.scrollHeight, document.body.offsetHeight),
      creative_id: creativeId,
    },
  });
}

export const fireFollowupSubmitTracking = ({ searchId, searchValue }) => {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_LINK_CLICK,
      action_name: TrackingConstant.VIEW_SEARCH_RESULT,
      subaction_name: TrackingConstant.VIEW_AUTO_COMPLETE_RESULT,
      creative_id: FOLLOWUP_CREATIVE_ID,
      value: `srp_search_id=${searchId}&search=${searchValue}`,
    },
  });
};

export const fireFollowupFocusTracking = () => {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_START,
    event_data: {
      action_category: TrackingConstant.USER_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_name: TrackingConstant.VIEW_SEARCH_RESULT,
      subaction_name: TrackingConstant.SELECT_AUTOCOMPLETE,
      creative_id: FOLLOWUP_CREATIVE_ID,
      value: 'Ask anything',
    },
  });
};
export const fireFollowupBlurTracking = () => {
  EventToolbox.fireTrackAction({
    event_type: TrackingConstant.EVENT_TYPE_ACTION_COMPLETED,
    event_data: {
      action_category: TrackingConstant.SYSTEM_ACTION_CATEGORY,
      action_cause: TrackingConstant.ACTION_CAUSE_USER_INPUT,
      action_name: TrackingConstant.VIEW_SEARCH_RESULT,
      subaction_name: TrackingConstant.ABANDON_AUTO_COMPLETE_RESULT,
      creative_id: FOLLOWUP_CREATIVE_ID,
    },
  });
};
